import GerenciadorEdi from "./gerenciadorEdi";
import {connect} from "react-redux";

export default connect()(GerenciadorEdi)
